import { render } from "./InterfaceIntegratedEditorCreateDialog.vue?vue&type=template&id=f3d59c12&scoped=true"
import script from "./InterfaceIntegratedEditorCreateDialog.vue?vue&type=script&lang=js"
export * from "./InterfaceIntegratedEditorCreateDialog.vue?vue&type=script&lang=js"

import "./InterfaceIntegratedEditorCreateDialog.vue?vue&type=style&index=0&id=f3d59c12&scoped=true&lang=scss"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3d59c12"]])

export default __exports__